export var EBreadcrumbKey;
(function (EBreadcrumbKey) {
    EBreadcrumbKey["repository"] = "repository";
    EBreadcrumbKey["media"] = "media";
    EBreadcrumbKey["recent"] = "repository";
    EBreadcrumbKey["books"] = "books";
    EBreadcrumbKey["contacts"] = "contacts";
    EBreadcrumbKey["subCategory"] = "subCategory";
})(EBreadcrumbKey || (EBreadcrumbKey = {}));
